import React, { useState } from 'react';
import { baseAPIURL } from '../../config';
import axios from 'axios';

const LoginPage = ({ SetIsLogin }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Basic validation
        if (!email) {
            setError('Please enter Email');
            return false;
        }
        if (!password) {
            setError('Please enter Password');
            return false;
        }
        if (!email || !password) {
            setError('Please enter both email and password');
            return false;
        }
        const headers = {
            // Authorization: `Bearer ${localStorage.getItem('pgAToken')}`,
            'Content-Type': 'application/json',
            // Authorization: `Bearer ${localStorage.getItem('pgAToken')}`,
        };
        try {
            const response = await axios.post(`${baseAPIURL}admin/login`, { email, password }, { headers: headers });
            // Handle form submission logic here
            console.error(response.data)
            if (response && response.data && response.data.data.length > 0 && response.data.status === 1) {
                setTimeout(() => {
                    SetIsLogin(true);
                }, 786);
            } else {
                SetIsLogin(false);
            }
            setError(response.data.message);
        } catch(e) {
            SetIsLogin(true);
            setError(e.message);
        }
        return true;
    };

    return (
        <>
            <section className="p-relative">
                <div className="container mt-4 mb-4">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <h2 className="text-center mb-4">Login</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="form-group mb-3">
                                    <label htmlFor="email">Email Address</label>
                                    <input
                                        type="email"
                                        id="email"
                                        className="form-control"
                                        placeholder="Enter your email"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="password">Password</label>
                                    <input
                                        type="password"
                                        id="password"
                                        className="form-control"
                                        placeholder="Enter your password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </div>

                                {error && <p className="text-danger">{error}</p>}

                                <button type="submit" className="btn btn-primary">
                                    Login
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default LoginPage;
